import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { FilledButton } from "../../customComponents/styled/styledButtons";

export default function SimilarSubjectDialog({
  open,
  onClose,
  similarSubject,
  onUpdateExisting,
  onCreateNew,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: "bold" }}>
        Similar Subject Exists
      </DialogTitle>
      <DialogContent>
        <Typography>
          A subject with a similar name "
          <strong>{similarSubject?.name}</strong>" already exists. Would you
          like to update the existing subject or proceed with creating a new
          one?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 0 }}>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button onClick={onUpdateExisting} variant="outlined" color="primary">
          Update Existing
        </Button>
        <FilledButton onClick={onCreateNew}>Create New Subject</FilledButton>
      </DialogActions>
    </Dialog>
  );
}
